// French translations (default)
export const fr = {
  // Header
  header: {
    excursions: 'Excursions',
    packages: 'Packages',
    howItWorks: 'Comment ça marche',
    reviews: 'Avis',
    faq: 'FAQ',
    whatsapp: 'WhatsApp',
    chatOnWhatsapp: 'Discuter sur WhatsApp'
  },

  // Hero
  hero: {
    badge: 'Français basé à Hurghada',
    title: 'Excursions à Hurghada',
    titleHighlight: 'en français',
    subtitle: 'Simples, fiables et sans stress',
    description: 'Je suis français, basé à Hurghada, et je vous aide à réserver des excursions testées et sélectionnées, avec des partenaires fiables.',
    cta: 'Discuter sur WhatsApp',
    ctaSubtext: 'Réponse rapide garantie',
    features: {
      french: 'Contact en français',
      selected: 'Activités sélectionnées',
      easy: 'Réservation simple via WhatsApp'
    }
  },

  // Excursions Section
  excursions: {
    badge: 'Nos activités',
    title: 'Excursions les plus demandées',
    subtitle: 'Des expériences sélectionnées et testées pour vous',
    viewDetails: 'Voir détails',
    inquire: 'Me renseigner'
  },

  // Packages Section
  packages: {
    badge: 'Séjours prolongés',
    title: 'Vous restez plusieurs jours ?',
    titleHighlight: 'Nos packages les plus choisis',
    subtitle: 'Des combinaisons d\'excursions pour profiter au maximum de votre séjour',
    included: 'INCLUS :',
    bookNow: 'Réserver ce pack',
    notSure: 'Pas sûr du meilleur pack pour vous ?',
    askAdvice: 'Demandez-moi conseil sur WhatsApp'
  },

  // How It Works
  howItWorks: {
    badge: 'Simple et rapide',
    title: 'Comment ça marche ?',
    subtitle: '2 étapes simples pour réserver votre excursion',
    steps: [
      {
        title: "Vous m'écrivez sur WhatsApp",
        description: 'Posez vos questions et dites-moi ce qui vous intéresse'
      },
      {
        title: 'Vous recevez tout',
        description: 'Horaires, points de RDV et infos pratiques pour chaque activité'
      }
    ]
  },

  // Testimonials
  testimonials: {
    badge: 'Témoignages',
    title: 'Ce que disent nos voyageurs',
    subtitle: 'Des avis authentiques de vrais clients'
  },

  // FAQ
  faq: {
    badge: 'Besoin d\'aide ?',
    title: 'Questions fréquentes',
    subtitle: 'Tout ce que vous devez savoir avant de réserver',
    moreQuestions: 'Vous avez d\'autres questions ? Je suis là pour vous aider.',
    askQuestion: 'Posez-moi votre question'
  },

  // Footer
  footer: {
    description: 'Votre contact français à Hurghada pour des excursions simples, fiables et sans stress.',
    quickLinks: 'Liens rapides',
    contact: 'Contact',
    contactText: 'Disponible tous les jours sur WhatsApp',
    chatNow: 'Discuter maintenant',
    copyright: '© 2025 Hurghada Excursions. Tous droits réservés.',
    madeWith: 'Site créé avec'
  },

  // Final CTA
  finalCta: {
    title: 'Prêt à vivre une expérience inoubliable ?',
    subtitle: 'Contactez-moi sur WhatsApp pour organiser votre excursion.',
    cta: 'Discuter sur WhatsApp'
  },

  // Activity Page
  activity: {
    backToMenu: 'Retour au menu',
    home: 'Accueil',
    perPerson: '/ personne',
    bookDeposit: 'Réserver – acompte sécurisé',
    securePayment: 'Paiement sécurisé · Acompte uniquement · Confirmation immédiate',
    depositNote: 'Le montant de l\'acompte peut varier selon l\'activité et la date. Le solde est à régler sur place le jour de l\'excursion.',
    needHelp: 'Besoin d\'aide ? WhatsApp',
    duration: 'Durée',
    departure: 'Départ',
    departureTime: 'Heure départ',
    return: 'Retour',
    itinerary: 'Déroulement de la journée',
    included: 'Inclus',
    notIncluded: 'Non inclus',
    question: 'Une question ?',
    questionSubtext: 'Je vous réponds rapidement en français sur WhatsApp.',
    trustFrench: 'Contact francophone',
    trustFrenchDesc: 'Je vous accompagne en français',
    trustPartners: 'Partenaires locaux',
    trustPartnersDesc: 'Sélectionnés et testés',
    trustPayment: 'Paiement sécurisé',
    trustPaymentDesc: 'Acompte Stripe + solde sur place',
    packsBadge: 'Économisez avec nos packs',
    packsTitle: 'Vous restez plusieurs jours ?',
    packsSubtitle: 'Découvrez nos packs d\'excursions et profitez de tarifs avantageux.',
    viewPacks: 'Voir les packs',
    faqTitle: 'Questions fréquentes',
    readyToBook: 'Prêt à réserver ?',
    readyToBookSubtitle: 'Confirmez votre place avec un acompte sécurisé.',
    availableDays: 'Jours disponibles',
    option: 'Option'
  },

  // Packs Page
  packs: {
    title: 'Nos Packages Excursions',
    subtitle: 'Combinez plusieurs excursions et économisez',
    backToHome: 'Retour à l\'accueil',
    depositFrom: 'Acompte :',
    remaining: 'Solde sur place :',
    book: 'Réserver ce pack'
  },

  // Common
  common: {
    learnMore: 'En savoir plus',
    bookNow: 'Réserver maintenant',
    contact: 'Contacter'
  }
};

export default fr;
